module.exports = __webpack_public_path__ + "media/images/home/en/preview-4-f99249bcdf1f87ada3d17a59fa957ff5.jpg";